import { useParams } from "react-router-dom";
import { PAGE_PATHS } from "../../components/navigation/PageContext";
import { SessionMode } from "../../contexts/appStore/hooks";
import { AppNavigate } from "./AppNavigate";
import { NavigateGlobalQuery } from "./queries";

/**
 * Logged-out visitors landing on an in-meeting URL (`/meeting/:id/...`) are
 * sent to that meeting's public lobby — the universal pre-join gate — instead
 * of the login page. Typical case: a guest reloading mid-meeting (guest
 * sessions are ephemeral and don't survive a reload).
 */
const PublicMeetingRedirect = () => {
  const { id } = useParams();
  if (!id) return <AppNavigate to={PAGE_PATHS[SessionMode.MASTER].login} replace />;
  // The lobby needs `provider` to resolve a provider-scoped id.
  return <AppNavigate to={`/lobby/${id}`} forwardParams={[NavigateGlobalQuery.PROVIDER]} replace />;
};

export default PublicMeetingRedirect;
